import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Dashboard.css';
import UserDashboard from '../../components/UserDashboard/UserDashboard';
import AdminDashboard from '../../components/AdminDashboard/AdminDashboard';

function Dashboard() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Le nom de l'utilisateur est directement disponible depuis le contexte
  const userName = user ? user.name : 'Utilisateur';
  const userRole = user ? user.role : 'user'; // 'user' par défaut si le rôle n'est pas défini

  return (
    <div className="dashboard-page">
      <div className="dashboard-container">
        <h2>Tableau de Bord</h2>
        <p>Bienvenue, {userName} !</p>

        {/* Aiguillage vers le bon tableau de bord */}
        {userRole === 'admin' ? <AdminDashboard /> : <UserDashboard />}
        <button onClick={handleLogout} className="logout-button">Se déconnecter</button>
      </div>
    </div>
  );
}

export default Dashboard;
